import React, { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getErrorMessage } from '../../utils/apiError';

export default function Login() {
  const { user, loading, login } = useAuth();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [verSenha, setVerSenha] = useState(false);
  const [manterSessao, setManterSessao] = useState(true);

  if (!loading && user) return <Navigate to="/dashboard" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setEnviando(true);
    try {
      await login(email, senha, manterSessao);
    } catch (err) {
      setErro(getErrorMessage(err, 'Erro ao entrar. Verifique suas credenciais.'));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="sf-login">
      <div className="sf-login-brand">
        <div className="sf-login-lockup">
          <svg width="112" height="112" viewBox="0 0 64 64" fill="none" aria-hidden="true">
            <rect
              x="1"
              y="1"
              width="62"
              height="62"
              rx="18"
              fill="rgba(255,255,255,0.08)"
              stroke="rgba(255,255,255,0.18)"
              strokeWidth="1.5"
            />
            <rect x="15" y="17" width="34" height="9" rx="4.5" fill="#f4e389" />
            <rect x="15" y="29.5" width="24" height="9" rx="4.5" fill="#ffffff" opacity="0.92" />
            <rect x="15" y="42" width="34" height="9" rx="4.5" fill="#ffffff" opacity="0.55" />
          </svg>
          <span className="sf-login-lockup-name">StoreFlow</span>
        </div>
        <div className="sf-login-brand-footer">StoreFlow · DataFit</div>
      </div>

      <div className="sf-login-panel">
        <div className="sf-login-card">
          <h1>Entrar</h1>

          <form className="sf-login-form" onSubmit={handleSubmit}>
            {erro && (
              <div className="sf-login-alert">
                <i className="bi bi-exclamation-circle" />
                {erro}
              </div>
            )}

            <label className="sf-field-label">
              <span>E-mail</span>
              <span className="sf-field">
                <i className="bi bi-envelope" />
                <input
                  type="email"
                  placeholder="voce@empresa.com"
                  required
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </span>
            </label>

            <label className="sf-field-label">
              <span className="sf-field-label-row">
                <span>Senha</span>
                <Link to="/esqueci-senha" className="sf-field-link">
                  Esqueci minha senha
                </Link>
              </span>
              <span className="sf-field">
                <i className="bi bi-lock" />
                <input
                  type={verSenha ? 'text' : 'password'}
                  required
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                />
                <button
                  type="button"
                  className="sf-field-toggle"
                  onClick={() => setVerSenha((v) => !v)}
                  aria-label={verSenha ? 'Ocultar senha' : 'Mostrar senha'}
                >
                  <i className={verSenha ? 'bi bi-eye-slash' : 'bi bi-eye'} />
                </button>
              </span>
            </label>

            <label className="sf-login-check">
              <input
                type="checkbox"
                checked={manterSessao}
                onChange={(e) => setManterSessao(e.target.checked)}
              />
              Manter sessão neste dispositivo
            </label>

            <button type="submit" className="sf-login-submit" disabled={enviando}>
              {enviando ? 'Entrando...' : 'Entrar'}
              {!enviando && <i className="bi bi-arrow-right" />}
            </button>
          </form>

          <div className="sf-login-footnote">
            <span>
              <i className="bi bi-shield-check" />
              Acesso restrito por empresa
            </span>
            <span>v1.4</span>
          </div>
        </div>
      </div>
    </div>
  );
}
